import { z } from "zod";

export const registerCompanySchema = z.object({
  company_name: z.string().trim().optional().or(z.literal("")),
  user_name: z.string().trim().optional().or(z.literal("")),
  hearing_schedule_preference: z.string().trim().min(1),
  plan_selection: z.enum(["assessment-only", "assessment-with-consult"]),
  user_email: z.string().trim().email(),
  user_password: z.string().min(8),
  user_password_confirmation: z.string().min(8),
  agree_to_terms: z.boolean(),
  cf_turnstile_response: z.string().trim().min(1),
});

export type RegisterCompany = z.infer<typeof registerCompanySchema>;
